import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { breakpoints } from "plos/src/styles/breakpoints";

export const costWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      flexDirection: "row",
      gap: vars.space.l,
    },
  },
});
